// components/layout/Footer.jsx
import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-gray-800 text-white py-4">
            <div className="container mx-auto px-4">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="mb-4 md:mb-0">
                        <p className="text-sm">© {new Date().getFullYear()} SmartRide 派車系統. 保留所有權利.</p>
                    </div>
                    <div className="flex space-x-4">
                        <a href="#" className="text-sm text-gray-300 hover:text-white">服務條款</a>
                        <a href="#" className="text-sm text-gray-300 hover:text-white">隱私政策</a>
                        <a href="#" className="text-sm text-gray-300 hover:text-white">聯絡我們</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;